/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { Button, Grid, TextField } from '@material-ui/core';
import CustomRange from './CustomRange';
import MultiSelectSearch from '../common/search/MultiSelectSearch';
import HorizontalMultiSelect from '../common/search/HorizontalMultiSelect';
import CustomGroupBasicDropDown from '../shared/CustomGroupBasicDropDown';

const ReportTab = ({
  title,
  selectedOption,
  classes,
  handleChange,
  options,
  periodIndex,
  handleChangePeriod,
  periodArr,
  email,
  openCustomDate,
  selectionRange,
  closeCustomRange,
  submit,
  handleSelect,
  handleEmailChange,
  emailRequired = true,
  dealershipRequired = true,
  dealershipPlaceholder = 'Select Dealerships',
  pxReport = false,
  examReport = false,
  handleExamChange,
  ...extraProps
}) => {
  let component;

  if (!pxReport && !examReport) {
    component = (
      <MultiSelectSearch
        placeholderButtonLabel={dealershipPlaceholder}
        selectedOptions={selectedOption}
        onChange={handleChange}
        options={options}
        width="300px"
        showValue
        labelWidth="210px"
        styles={{
          control: (provided) => ({
            ...provided,
            backgroundColor: '#f4f4f4',
          }),
          dropdownButton: (provided) => ({
            ...provided,
            backgroundColor: '#f4f4f4',
          }),
        }}
        {...extraProps}
      />
    );
  } else if (pxReport && !examReport) {
    component = (
      <HorizontalMultiSelect
        list={options}
        selectedList={selectedOption}
        placeholderButtonLabel={dealershipPlaceholder}
        searchPlaceholder="Search Dealerships"
        setSelectedList={handleChange}
        inputWidth="17vw"
        popoverWidth="17vw"
      />
    );
  } else {
    component = (
      <div>
        <CustomGroupBasicDropDown
          handleChange={handleExamChange}
          value={selectedOption}
          width="100%"
          height="44px"
          marginBottom="20px"
          list={options}
          name="grouped-select"
          disabled={false}
          groupKey="section"
          labelKey="name"
        />
      </div>
    );
  }

  return (
    <Grid container direction="column">
      <Grid item>
        <Grid container direction="column" className={classes.reportFrame}>
          <Grid item>
            <Grid container direction="row">
              <Grid item className={classes.title}>
                {title}
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container direction="row">
              <Grid item xs={4}>
                <Grid container direction="column">
                  <Grid item>
                    <div className={classes.dealLabels}>
                      <label htmlFor="courseOverview" className={dealershipRequired ? classes.required_field : ''}>
                        {`${!examReport ? 'Dealership Name' : 'Exams'}`}
                      </label>
                    </div>
                    <div style={{ marginLeft: '25px', marginRight: '10px' }}>{component}</div>
                  </Grid>
                </Grid>
              </Grid>
              {!examReport && (
                <>
                  <Grid item xs={4}>
                    <Grid container direction="column">
                      <Grid item>
                        <div className={classes.rangeLabel}>
                          <label htmlFor="courseOverview">Time Period</label>
                        </div>
                        <select
                          name="period"
                          id="periodId"
                          value={periodIndex}
                          className={classes.periodField}
                          onChange={handleChangePeriod}
                        >
                          {periodArr?.map((dept, index) => (
                            <option value={index}>{dept}</option>
                          ))}
                        </select>
                      </Grid>
                      {openCustomDate && (
                        <Grid item style={{ width: '0vw' }}>
                          <CustomRange
                            selectionRange={selectionRange}
                            handleSelect={handleSelect}
                            close={closeCustomRange}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                  <Grid item xs={4}>
                    <div className={classes.emailLabel}>
                      <label htmlFor="courseOverview" className={emailRequired ? classes.required_field : ''}>
                        Email
                      </label>
                    </div>
                    <TextField
                      id="email_id"
                      name="email"
                      required
                      autoFocus
                      autoComplete="off"
                      autoSave="off"
                      onChange={handleEmailChange}
                      placeholder="Enter email id"
                      multiline
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: classes.emailField,
                        },
                      }}
                      value={email}
                      rows={1}
                    />
                    <Grid item className={classes.subtitle}>
                      Report will be sent to the above e-mail address
                    </Grid>
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
          <Grid item>
            <Grid container direction="row">
              <Grid item>
                <Button variant="contained" color="primary" className={classes.sendBtn} onClick={submit}>
                  Send
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ReportTab;
